import { Component, Input, QueryList, ViewChildren } from '@angular/core';
import {
  RolloverPropertyTransferredOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-property-transferred.options';
import {
  WarningArrayItemDeletionComponent,
} from '../../../../warning-array-item-deletion/warning-array-item-deletion.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RolloverPropertyFormComponent } from '../rollover-property-form/rollover-property-form.component';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';


@Component({
  selector: 'app-rollover-properties-form',
  templateUrl: './rollover-properties-form.component.html',
  styleUrls: ['./rollover-properties-form.component.scss'],
  standalone: false,
})
export class RolloverPropertiesFormComponent {

  @Input()
  propertyTransferred: AdvancedFormArray<RolloverPropertyTransferredOptions>;
  @Input()
  form: AdvancedForm<RolloverOptions>;

  @ViewChildren('property')
  propertyComponents: QueryList<RolloverPropertyFormComponent>;

  constructor(public modalService: NgbModal) {

  }

  async removePropertyTransferred(propertyTransferredIndexToRemove: number) {
    const modal = this.modalService.open(WarningArrayItemDeletionComponent);
    (modal.componentInstance as WarningArrayItemDeletionComponent).objectDefinition = 'cette propriété transférée';
    modal.closed.subscribe(async result => {
      if (result === true) {
        // Here we delete only in the form, not syncing the change to the server or else deleting could cause bad data to be sync.
        this.propertyTransferred.delete(propertyTransferredIndexToRemove);

        return;
      }
    });

    return;
  }

  addPropertyTransferred() {
    this.propertyTransferred.appendNew();
  }

  // refresh(){
  //     this.propertyComponents.forEach(item => item.refresh())
  // }
}
